import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 86917 78394"
    {...props}
  >
    <path
      d="M21635 56536 10817 75271 0 56536h21635zm16225 21858H16225l10818-18736 10817 18736zm11197 0 10817-18736 10818 18736H49057zm-5599-3231L32641 56427h21635L43458 75163zm21824-18627h21635L76100 75271 65282 56536zm10818-24981 10817 18735H65282l10818-18735zm-65283 0 10818 18735H0l10817-18735zm32641-110 10818 18737H32641l10817-18737zm27043-3123L59684 47058 48867 28322h21634zm-54085 0h21634L27233 47058 16416 28322zm54085-6464H48867L59684 3123l10817 18735zm-54085 0L27233 3123l10817 18735H16416zm27042-3122L32641 0h21635L43458 18736z"
      style={{
        fill: "#000",
      }}
      className="fill"

    />
  </svg>
)
export default SvgComponent
